<script>

	export let ref;
	export let value = '';
	export let err;
	export let inputmode = 'text';
	export let inFocus;
	export let placeholder;
	export let maxlength;
	export let disabled;

	function handleFocus() {
		inFocus = true;
	}

	function handleBlur() {
		inFocus = false;
	}

</script>

<style>
	input {
		box-sizing: border-box;
		width: 100%;
		border: 1px solid var(--blend-40);
		background: var(--blend-05);
		color: var(--textColor);
		padding: 0.8rem 1rem;
		line-height: 1;
		font-size: 0.8rem;
		border-radius: 3px;
	}
	input.err {
		border-color: var(--red);
	}
	input:focus {
		outline: none;
		border-color: var(--textColor);
	}
	input::-webkit-input-placeholder {
		color: var(--blend-40);
	}
	input::-moz-placeholder {
		color: var(--blend-40);
	}
</style>

<input
	type="text"
	id={ref}
	bind:value={value}
	{inputmode}
	{maxlength}
	autocomplete="off"
	class:err
	on:focus={handleFocus}
	on:blur={handleBlur}
	{placeholder}
	{disabled}
/>